import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: auditReports.GipReportScheduleDto[];
}

export const GipReportUnmatchedSchedulesView = ({ schedules }: Props) => {
  const columns = useGipResultColumnsFactory();

  const tableColumns = [
    columns.station,
    columns.dateTime,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.materialStatus,
    columns.contract,
    columns.order,
    columns.actions,
  ] as unknown as MRT_ColumnDef<auditReports.GipReportScheduleDto>[];

  return <MrtTable<auditReports.GipReportScheduleDto> data={schedules} columns={tableColumns} />;
};
